import React from 'react';
import {Stack} from '@mui/material';
import {
  Body,
  Button,
  designSystemToken,
  Headline,
  Icon,
  Label,
  Tooltip,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface RephraseDisclaimerProps {
  requiredCredits: number;
  actionEnabled: boolean;
  onSubmit: () => void;
  isLoading: boolean;
  buttonTooltip?: string;
}

function RephraseDisclaimer({
  requiredCredits,
  actionEnabled,
  onSubmit,
  isLoading,
  buttonTooltip,
}: RephraseDisclaimerProps) {
  return (
    <Stack
      direction="column"
      bgcolor={designSystemToken('semantic.bg.primary')}
      paddingX="36px"
      paddingY="32px"
      spacing="8px"
      width="60%"
    >
      <Stack
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="24px"
        alignSelf="stretch"
        height="100%"
      >
        <Stack spacing="8px">
          <Headline
            size="xl"
            color={designSystemToken('semantic.fg.primary')}
            whiteSpace="pre-line"
            textAlign="center"
          >
            {translate('Pull the script from your video')}
          </Headline>
          <Headline
            size="lg"
            color={designSystemToken('semantic.fg.secondary')}
            whiteSpace="pre-line"
            textAlign="center"
          >
            {translate('Video must contain speech')}
          </Headline>
        </Stack>
        <Tooltip arrow type="light" placement="top" title={buttonTooltip}>
          <div>
            <Button
              appearance="neutral"
              onClick={onSubmit}
              size="large"
              mode="filled"
              isLoading={isLoading}
              disabled={isLoading || !actionEnabled}
              icon={
                <Icon
                  size="medium"
                  appearance="neutral"
                  name="Actions-Send"
                  color={designSystemToken('semantic.fg.white')}
                />
              }
              iconPosition="end"
              sx={{width: '200px'}}
            >
              <Label size="lg" color={designSystemToken('semantic.fg.white')}>
                {translate('Pull Script')}
              </Label>
            </Button>
          </div>
        </Tooltip>
        <Body
          size="xl"
          color={designSystemToken('semantic.fg.secondary')}
          whiteSpace="pre-line"
          textAlign="center"
          dangerouslySetInnerHTML={{
            __html: translate(
              'This uses X video credits and covers all your rephrases for this script. If no edits are made, you’ll get a full refund in 24 hours.',
              {count: requiredCredits}
            ),
          }}
        />
      </Stack>
    </Stack>
  );
}

export default RephraseDisclaimer;
